import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "@/shared/components/toast";

interface CopyBlockProps {
  code: string;
  label?: string;
}

export function CopyBlock({ code, label }: CopyBlockProps) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      toast.success("Copiado al portapapeles");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("No se pudo copiar");
    }
  };

  return (
    <div>
      {label && (
        <p className="text-xs font-semibold text-foreground/50 uppercase tracking-widest mb-2">
          {label}
        </p>
      )}
      <div className="relative group">
        <pre className="overflow-x-auto rounded-2xl bg-[#1d1d1f] text-[#f5f5f7] text-xs leading-relaxed p-4 pr-14 font-mono">
          <code>{code}</code>
        </pre>
        <button
          onClick={copy}
          title="Copiar"
          className="absolute top-3 right-3 p-2 rounded-lg bg-white/10 hover:bg-white/20 text-white/80 transition-colors cursor-pointer"
        >
          {copied ? <Check className="size-4" /> : <Copy className="size-4" />}
        </button>
      </div>
    </div>
  );
}
